import { render, staticRenderFns } from "./endesa.vue?vue&type=template&id=8e06960a&"
import script from "./endesa.vue?vue&type=script&lang=js&"
export * from "./endesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports